import { createContext } from 'preact';
import type { SetStateAction } from 'preact/compat';
import type { Dispatch } from 'preact/hooks';

import type { Country } from '../../components/InputPhone/model';

interface PhoneContextProps {
  phoneNumber?: string;
  setPhoneNumber?: Dispatch<SetStateAction<string>>;
  selectedCountry?: Country;
  setSelectedCountry?: (country: Country) => void;
  onPhoneSubmit?: () => void;
  setOnPhoneSubmit?: (callback: () => void) => void;
  onPhoneCancel?: () => void;
  setOnPhoneCancel?: (callback: () => void) => void;
  showPhoneInput?: () => void;
  setShowPhoneInput?: (callback: () => void) => void;
}

export const PhoneContext = createContext<PhoneContextProps>({});
